import { render, staticRenderFns } from "./single_user.vue?vue&type=template&id=061f1b8f"
import script from "./single_user.vue?vue&type=script&lang=js"
export * from "./single_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports